import { parseAndApplyStateFromRemote } from '../utils/sync';
import { throttle } from '../utils/utils';
import { getSyncHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

type WriteSyncFunction = (stateData: any, room: number, action: any, session: string, token: string) => Promise<void>;

export const WriteSyncState = async (stateData: any, room: number, action: any, session: string, token: string) => {
	return fetch(`${getSyncHost()}/write-state`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'bl-token': token,
		},
		body: JSON.stringify({
			stateData,
			room,
			action,
			session,
			timestamp: new Date().valueOf(),
		}),
	}).catch(error => {
		logger.error(error);
	});
};

export const ThrottledWriteSyncState: WriteSyncFunction = (throttle(WriteSyncState, 2000) as unknown as WriteSyncFunction);

export const RequestSyncedState = async (room: number, token: string, applyState: boolean = true) => {
	return fetch(`${getSyncHost()}/request-state/${room}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'bl-token': token,
		},
	}).then(async res => {
		const state = await res.json();
		
		if(applyState) {
			parseAndApplyStateFromRemote(state);
		}
		
		return state;
	}).catch(error => {
		logger.error(error);
	});
};

export const GetSyncedTime = async (token: string) => {
	const startTime = new Date().valueOf();
	return fetch(`${getSyncHost()}/get-time/`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'bl-token': token,
		},
	}).then(async res => {
		const payload = await res.json();
		//add the time it took to make the call
		return payload.time + (new Date().valueOf() - startTime);
	}).catch(error => {
		logger.error(error);
	});
};